export const parseWKTPolygon = (wktString) => {
    if (!wktString) return [];

    const match = wktString.match(/\(\(([^)]+)\)\)/);
    if (!match) return [];

    return match[1]
        .trim()
        .split(',')
        .map(pair => {
            const [lng, lat] = pair.trim().split(' ').map(Number);
            return [lng, lat];
        });
};
